module.exports = __webpack_public_path__ + "img/35a)Kempinski Hotel St. Moritz.jpg";